




import Vue from 'vue';

export default Vue.extend({
	data() {
		return {
			showIframe: true,
		};
	},
	computed: {
		wmsAdminUrl() {
			return `${this.dmsSys.DMSC_url}/wms/WmsAdmin`;
		},
	},
});
